
import { CREATIVE_VAST_ACTIONS } from "reducers/actions/Creatives";
import { loadCreatives } from "reducers/Creatives";
import { SUPPRESS_ERROR_GROWL, SUPPRESS_SUCCESS_GROWL, VAST_DYNAMIC } from "utils/constants";

import { addNotification } from "../Notifications";

export function loadVideoSpecs(libraryId, creativeId){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_SPECS_AJAX,
			AJAX:{
				url:`creativelibraries/${libraryId}/creatives/${creativeId}/video-specs`,
				success:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_SPECS_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_SPECS_ERROR,
			},
			meta:{ ...SUPPRESS_SUCCESS_GROWL },
		});
	};
}

export function loadAudioSpecs(creativeId){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_AUDIO_SPECS_AJAX,
			AJAX:{
				url:`creatives/${creativeId}/audio-specs`,
				success:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_AUDIO_SPECS_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.LOAD_CREATIVE_VAST_AUDIO_SPECS_ERROR,
			},
			meta:{ ...SUPPRESS_SUCCESS_GROWL },
		});
	};
}

export function setVASTUploadList(fileList){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.SET_UPLOAD_LIST,
			payload:{ fileList },
		});
	};
}

function initUploadList(state, action){
	return {
		...state,
		vastItems: action.payload.fileList,
	};
}

export function uploadVASTCreative(libraryId, file, cancelToken, replaceCreative = false, dynamicValue){
	let formData = new FormData()
		, url = `creative-libraries/${libraryId}/vast-creatives/upload`
		, method = "post"
		;

	if(replaceCreative) {
		url = `creative-libraries/${libraryId}/vast-creatives/${replaceCreative.id}`;
		method = "put";
		formData.append("file", file);
	} else {
		formData.append("files", file);
		if(dynamicValue === VAST_DYNAMIC) {
			url += '?isDynamic=true';
		}
	}

	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_AJAX,
			AJAX:{
				url,
				method,
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
				success: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_ERROR,
				onUploadProgress(progress){
					dispatch({
						type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_PROGRESS,
						payload:{
							uploadName:file.name,
							progress:progress.loaded,
						},
					});
				},
				cancelToken,
			},
			payload:{ uploadName: file.name },
			meta: { suppressGrowl: !replaceCreative },
		}).then((response) => {
			const { data = {} } = response.payload;
			const { creatives = [], errors = []} = data;

			if (creatives.length) { return response; }

			errors.forEach((error = {}) => {
				const [message] = error.errors;

				if (message) {
					dispatch(addNotification({
						messageHeader: file.name,
						message: message.error,
						type: "error",
					}));
				}
			});

			return response;
		});
	};
}

export function encodeVASTCreatives(libraryId, assetIds = [], replaceCreative = false, dynamicValue){
	let videos = assetIds.map((id) => { return { id }; })
		, url = `creative-libraries/${libraryId}/vast-creatives`
		, method = "post"
		, data = { videos }
		;

	if(replaceCreative) {
		url = `creative-libraries/${libraryId}/vast-creatives/${replaceCreative.id}/link`;
		method = "put";
		data = { video:videos[0] };
	}

	if(dynamicValue === VAST_DYNAMIC) {
		data.videos.forEach(dynamicData => Object.assign(dynamicData, { isDynamic: true }));
	}

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.ENCODE_VAST_CREATIVES_AJAX,
			AJAX: {
				url,
				method,
				data,
				success: CREATIVE_VAST_ACTIONS.ENCODE_VAST_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.ENCODE_VAST_CREATIVES_ERROR,
			},
			meta: { suppressGrowl: !replaceCreative },
		}).then((response) => {
			if(replaceCreative){ return; }

			let { data = []} = response?.payload || {};

			let failed = data.filter(datum => datum.success === false);
			let numSuccessful = data.length - failed.length;
			let isDynamic = (dynamicValue === VAST_DYNAMIC);

			if(numSuccessful){
				dispatch(addNotification({
					message: encodeVastGrowls(numSuccessful, isDynamic),
					type: "success",
				}));
				dispatch(loadCreatives(libraryId));
			}

			const baseDelay = 4000;
			const interval = 750;

			for(let i=0; i<failed.length; i++){
				let { item } = failed[i];
				dispatch(addNotification({
					messageHeader: item.request.name,
					message: item.response,
					type: "error",
					dismissIn: baseDelay + (i * interval),
				}));
			}
		});
	};
}

export function uploadVASTImposiumCreative(libraryId, file, cancelToken) {
	const formData = new FormData();
	formData.append("files", file);

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_IMPOSIUM_CREATIVES_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/vast-creatives-upload`,
				method: "post",
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
				success: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_IMPOSIUM_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_IMPOSIUM_CREATIVES_ERROR,
				cancelToken,
			},
			payload: { uploadName: file.name, isSingleArrayCreative: true, useCreativeName: true },
		});
	};
}

export function encodeVASTImposiumCreative(libraryId, assetIds = []) {
	const videos = assetIds.map(id => ({ id }));

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.ENCODE_VAST_IMPOSIUM_CREATIVES_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/vast-creatives`,
				method: "post",
				data: { videos },
				success: CREATIVE_VAST_ACTIONS.ENCODE_VAST_IMPOSIUM_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.ENCODE_VAST_IMPOSIUM_CREATIVES_ERROR,
			},
			payload: { isSingleArrayCreative: true, useCreativeName: true },
		});
	};
}


export function uploadVASTAfterEffectsCreative(libraryId, file, cancelToken, autoCreateAEVersionRenderAssets = false) {
	const formData = new FormData();
	formData.append("file", file);
	let params = undefined;
	if (autoCreateAEVersionRenderAssets) {
		params = { autoCreateAEVersionRenderAssets };
	}

	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_AJAX,
			AJAX:{
				url: `ui/creative-libraries/${libraryId}/after-effects/vast-creatives-upload`,
				method: "post",
				data: formData,
				params,
				headers: { "Content-Type": "multipart/form-data" },
				success: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVES_ERROR,
				cancelToken,
				onUploadProgress(progress){
					dispatch({
						type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_PROGRESS,
						payload:{
							uploadName:file.name,
							progress:progress.loaded,
						},
					});
				},
			},
			payload:{ uploadName: file.name },
			meta: { suppressGrowl: true },
		});
	};
}

export function encodeVASTAfterEffectsCreative(libraryId, assetIds = [], autoCreateAEVersionRenderAssets = false) {
	let packages = assetIds.map(id => ({ id }));
	let data = { afterEffectsPackages: packages };
	if (autoCreateAEVersionRenderAssets) {
		data.autoCreateAEVersionRenderAssets = true;
	}

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.ENCODE_AFTER_EFFECTS_CREATIVES_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/after-effects/vast-creatives`,
				method: "post",
				data,
				success: CREATIVE_VAST_ACTIONS.ENCODE_AFTER_EFFECTS_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.ENCODE_AFTER_EFFECTS_CREATIVES_ERROR,
			},
			meta: { suppressGrowl: true },
		}).then((response) => {
			const { creatives = []} = response?.payload?.data || {};

			if (creatives.length) {
				dispatch(addNotification({
					message: encodeVastGrowls(creatives.length, true),
					type: "success",
				}));
				dispatch(loadCreatives(libraryId));
			}

			/*
				Not attaching error notification since here unlike other VAST creatives since no errors
				are returned for each individual pacakage
			*/
		});
	};
}

export function uploadVASTAudioCreative(libraryId, file, cancelToken, replaceCreative = false, ajaxOptions = {}){
	const formData = new FormData();
	let url = `creative-libraries/${libraryId}/vast-audio-creatives/upload`;
	let method = "post";

	if(replaceCreative) {
		url = `creative-libraries/${libraryId}/vast-audio-creatives/${replaceCreative.id}`;
		method = "put";
		formData.append("file", file);
	} else {
		formData.append("files", file);
	}

	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_AJAX,
			AJAX:{
				url,
				method,
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
				success: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_ERROR,
				onUploadProgress(progress){
					dispatch({
						type:CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_PROGRESS,
						payload:{
							uploadName: file.name,
							progress: progress.loaded,
						},
					});
				},
				cancelToken,
				...ajaxOptions,
			},
			payload:{
				uploadName: file.name,
			},
			meta: { suppressGrowl: !replaceCreative },
		}).then((response) => {
			const { data = {} } = response.payload;
			const { creatives = [], errors = []} = data;

			if (creatives.length) { return response; }

			errors.forEach((error = {}) => {
				const [message] = error.errors;

				if (message) {
					dispatch(addNotification({
						messageHeader: file.name,
						message: message.error,
						type: "error",
					}));
				}
			});

			return response;
		});
	};
}

export function encodeVASTAudioCreatives(libraryId, assetIds = [], replaceCreative = false) {
	const audios = assetIds.map((id) => { return { id }; });
	let url = `creative-libraries/${libraryId}/vast-audio-creatives`;
	let method = "post";
	let data = { audios };

	if(replaceCreative) {
		url = `creative-libraries/${libraryId}/vast-audio-creatives/${replaceCreative.id}/link`;
		method = "put";
		data = { audio: audios[0] };
	}

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.ENCODE_VAST_AUDIO_CREATIVES_AJAX,
			AJAX: {
				url,
				method,
				data,
				success: CREATIVE_VAST_ACTIONS.ENCODE_VAST_AUDIO_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.ENCODE_VAST_AUDIO_CREATIVES_ERROR,
			},
			meta: { suppressGrowl: !replaceCreative },
		}).then((response) => {
			if (replaceCreative) { return; }

			let { data = []} = response?.payload || {};
			let failed = data.filter(datum => datum.success === false);
			let numSuccessful = data.length - failed.length;

			if(numSuccessful){
				dispatch(addNotification({
					message: encodeVastAudioGrowls(numSuccessful),
					type: "success",
				}));
				dispatch(loadCreatives(libraryId));
			}

			const baseDelay = 4000;
			const interval = 750;

			for(let i = 0; i < failed.length; i++){
				let { item } = failed[i];
				dispatch(addNotification({
					messageHeader: item.request.name,
					message: item.response,
					type: "error",
					dismissIn: baseDelay + (i * interval),
				}));
			}
		});
	};
}

export function encodeVastAudioGrowls(numSuccessful) {
	let pluralizer = (numSuccessful > 1) ? "s" : "";

	return `Successfully created ${numSuccessful} VAST Audio Creative${pluralizer}`;
}

export function encodeVastGrowls(numSuccessful, isDynamic) {
	let pluralizer = (numSuccessful > 1) ? "s" : "";

	if(isDynamic) {
		return `${numSuccessful} dynamic VAST Creative${pluralizer} ${numSuccessful > 1 ? 'are' : 'is'} processing`;
	} else {
		return `Successfully created ${numSuccessful} VAST Creative${pluralizer}`;
	}
}

export function createBlankImposiumCreative(libraryId, values) {
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_CREATIVE_AJAX,
			AJAX:{
				url: `ui/creative-libraries/${libraryId}/imposium/blank-creatives`,
				method: "post",
				data: { creatives: [{ ...values }]},
				success: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_CREATIVE_ERROR,
			},
			payload:{
				isSingleArrayCreative: true,
				useCreativeName: true,
			},
			meta: { ...SUPPRESS_ERROR_GROWL },
		});
	};
}

// Audio Imposium Functions
export function uploadAudioImposiumCreative(libraryId, file, cancelToken) {
	const formData = new FormData();
	formData.append("files", file);

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/audio-creatives-upload`,
				method: "post",
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
				success: CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_ERROR,
				onUploadProgress(progress) {
					dispatch({
						type: CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_PROGRESS,
						payload: {
							uploadName: file.name,
							progress: progress.loaded,
						},
					});
				},
				cancelToken,
			},
			payload: { uploadName: file.name, isSingleArrayCreative: true, useCreativeName: true },
		});
	};
}

export function encodeAudioImposiumCreative(libraryId, assetIds = []) {
	const audios = assetIds.map(id => ({ id }));

	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.ENCODE_AUDIO_IMPOSIUM_CREATIVES_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/audio-creatives`,
				method: "post",
				data: { audios },
				success: CREATIVE_VAST_ACTIONS.ENCODE_AUDIO_IMPOSIUM_CREATIVES_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.ENCODE_AUDIO_IMPOSIUM_CREATIVES_ERROR,
			},
			payload: { isSingleArrayCreative: true, useCreativeName: true },
		});
	};
}

export function createBlankImposiumAudioCreative(libraryId, projectName, creatives) {
	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/audio-project`,
				method: "post",
				data: { projectName, creatives },
				success: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_ERROR,
			},
			payload: {
				isSingleArrayCreative: true,
				useCreativeName: true,
			},
			meta: { ...SUPPRESS_ERROR_GROWL },
		});
	};
}

export function createImposiumAudioFromProject(libraryId, projectId, creatives) {
	return (dispatch) => {
		return dispatch({
			type: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/imposium/project/${projectId}/audio-creatives`,
				method: "post",
				data: { creatives },
				success: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_SUCCESS,
				error: CREATIVE_VAST_ACTIONS.CREATE_BLANK_IMPOSIUM_AUDIO_CREATIVE_ERROR,
			},
			payload: {
				isSingleArrayCreative: true,
				useCreativeName: true,
			},
			meta: { ...SUPPRESS_ERROR_GROWL },
		});
	};
}

export function encodeAudioImposiumGrowls(numSuccessful) {
	let pluralizer = (numSuccessful > 1) ? "s" : "";

	return `${numSuccessful} dynamic Audio Creative${pluralizer} ${numSuccessful > 1 ? 'are' : 'is'} processing`;
}


export function createPartnerVastCreative(libraryId, creatives){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_AJAX,
			AJAX:{
				url:`ui/creative-libraries/${libraryId}/bulk-creatives`,
				method:"post",
				data:creatives,
				success:CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_ERROR,
			},
			meta:{
				buildMessage:buildPartnerMessage(),
			},
		});
	};
}

export function savePartnerVastTag(creativeId, data){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_AJAX,
			AJAX:{
				url:`ui/creatives/${creativeId}`,
				method:"put",
				data,
				success:CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_ERROR,
			},
			meta:{
				buildMessage:buildPartnerMessage(),
			},
		});
	};
}

function buildPartnerMessage(){
	return function buildMessage(response, success){
		let id = new Date().toString();

		if(success){
			return {
				type: "success",
				id,
				messageHeader: "Success!",
				message: "Partner VAST Creatives Saved",
			};
		}

		return {
			type: "error",
			id,
			messageHeader: "Error!",
			message: "Error Saving Partner VAST Creatives",
		};
	};
}

function updateVastItem(currentList, itemName, updateInfo){
	let currentIdx = currentList.findIndex(v => v.name === itemName)
		, currentItem = currentList[currentIdx]
		;

	currentList[currentIdx] = {
		...currentItem,
		...updateInfo,
	};

	return currentList;
}

function setUploadProgress(state, action){
	let { uploadName, progress } = action.payload
		, newVASTItems = [].concat(state.vastItems)
		;

	return {
		...state,
		vastItems:updateVastItem(newVASTItems, uploadName, { progress }),
	};
}

function setUploadResult(state, action){
	/*
		Even though the api returns a success, the upload may have errored out. We need to verify the creatives
		and error arrays that are returned from the endpoint.

		Uploads are handled one at a time, so the error object will always be in the 0 index of the errors array.

		Shape of the errors array:
		data: {
			errors: [
				{ // Errors for first file (or only file in our case)
					errors: [
						{ error: "Error 1" },
						{ error: "Error 2" },
						{ error: "Error 3" },
					]
				}
			]
		}
	*/
	const { original, data = {} } = action.payload;
	const { uploadName } = original;
	const newVASTItems = [...state.vastItems];

	const { creatives = [], errors = []} = data;
	const success = creatives.length && !errors.length;
	const [errorObj = {}] = errors;
	const error = !creatives.length ? errorObj.errors?.map(({ error = '' }) => error).join('') : false;

	return {
		...state,
		vastItems: updateVastItem(newVASTItems, uploadName, { success, error }),
	};
}

/**
 * Handle upload result for After Effects VAST
 *
 * Uploading VAST After Effects Creatives return a different response object than vast creatives.
 * Success responses will return the object of the SINGLE created VAST After Effects Creative.
 *
 * When the upload errors out it will be handled in the error action as it returns a [404] response.
*/
function setAfterEffectsUploadResult(state, action) {
	const { original = {} } = action.payload;
	const { uploadName } = original;
	const newVASTItems = [...state.vastItems];

	return {
		...state,
		vastItems: updateVastItem(newVASTItems, uploadName, { success: true, error: false }),
	};
}

function setUploadError(state, action){
	let { errorObj } = action.payload
		,  { uploadName } = action.payload.original
		, newVASTItems = [].concat(state.vastItems)
		;

	return {
		...state,
		vastItems: updateVastItem(newVASTItems, uploadName, { error: errorObj }),
	};
}

function isSavingPartnerVast(state, action){
	return {
		...state,
		isSavingPartnerVast:true,
		partnerErrors:null,
	};
}

function isSavingPartnerVastSuccess(state, action){
	return {
		...state,
		isSavingPartnerVast:false,
		partnerErrors:null,
		items:[].concat(action.payload.data.creatives, state.items),
	};
}

function isSavingPartnerVastEditSuccess(state, action){
	let { payload } = action;

	return {
		...state,
		items:state?.items.map((v) => {
			if(v.id === payload.data.id){
				return {
					...v,
					vastTag:payload.data.vastTag,
				};
			}

			return v;
		}),
		isSavingPartnerVast:false,
		partnerErrors:null,
	};
}

function isSavingPartnerVastError(state, action){
	return {
		...state,
		isSavingPartnerVast:false,
		partnerErrors:action.payload.data,
	};
}

export const HANDLERS = {
	[CREATIVE_VAST_ACTIONS.SET_UPLOAD_LIST]:initUploadList,

	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_PROGRESS]:setUploadProgress,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_SUCCESS]:setUploadResult,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_CREATIVE_ERROR]:setUploadError,

	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVE_PROGRESS]: setUploadProgress,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVE_SUCCESS]: setAfterEffectsUploadResult,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AFTER_EFFECTS_CREATIVE_ERROR]: setUploadError,

	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_PROGRESS]: setUploadProgress,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_SUCCESS]: setUploadResult,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_AUDIO_CREATIVE_ERROR]: setUploadError,

	[CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_PROGRESS]: setUploadProgress,
	[CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_SUCCESS]: setUploadResult,
	[CREATIVE_VAST_ACTIONS.UPLOAD_AUDIO_IMPOSIUM_CREATIVE_ERROR]: setUploadError,

	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_IMPOSIUM_CREATIVES_AJAX]: setUploadProgress,
	[CREATIVE_VAST_ACTIONS.UPLOAD_VAST_IMPOSIUM_CREATIVES_ERROR]: setUploadError,

	[CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_AJAX]:isSavingPartnerVast,
	[CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_SUCCESS]:isSavingPartnerVastSuccess,
	[CREATIVE_VAST_ACTIONS.CREATE_PARTNER_VAST_ERROR]:isSavingPartnerVastError,

	[CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_AJAX]:isSavingPartnerVast,
	[CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_SUCCESS]:isSavingPartnerVastEditSuccess,
	[CREATIVE_VAST_ACTIONS.EDIT_PARTNER_VAST_ERROR]:isSavingPartnerVastError,
};

export const PRIVATE = {
	buildPartnerMessage,
	isSavingPartnerVast,
	isSavingPartnerVastSuccess,
	isSavingPartnerVastError,
	isSavingPartnerVastEditSuccess,
};
